import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Typography,
  useTheme,
  useMediaQuery,
  TextField,
  CardContent,
} from "@mui/material";
import { getAppConfig } from "../../../redux/Configuration/configurationSlice";

import { getBookingReportRequest } from "../../../redux/BookingBullion/bookingBullionSlice";
import TableCompo from "../Table/TableCompo";
import FeatureUnavailable from "../../Comman/FeatureUnavailable";

const BookingReport = () => {
  const dispatch = useDispatch();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [search, setSearch] = useState("");

  const decimal = useSelector(
    (state) => state?.appConfig?.configData?.decimalPrecision || 4,
  );

  const [pagination, setPagination] = useState({
    page: 0,
    limit: 10,
  });

  const { bookingReport, bookingReportTotal, bookingReportLoading } =
    useSelector((state) => state.bookingBullion);
  const configData = useSelector((state) => state.appConfig.configData);

  useEffect(() => {
    dispatch(getAppConfig());
  }, []);

  useEffect(() => {
    dispatch(
      getBookingReportRequest({
        page: pagination.page + 1,
        limit: pagination.limit,
        search,
      }),
    );
  }, [dispatch, pagination, search]);

  const handleTableChange = (action, tableState) => {
    switch (action) {
      case "changePage":
        setPagination((prev) => ({
          ...prev,
          page: tableState.page,
        }));
        break;

      case "changeRowsPerPage":
        setPagination({
          page: 0,
          limit: tableState.rowsPerPage,
        });
        break;

      case "search":
        setSearch(tableState.searchText || "");

        setPagination((prev) => ({
          ...prev,
          page: 0,
        }));
        break;

      default:
        break;
    }
  };
  if (configData?.featureToggle?.Booking_Bullion !== true) {
    return <FeatureUnavailable heading="Booking Report" />;
  }

  const columns = [
    {
      field: "jewellerName",
      headerName: "Jeweller Name",
    },
    {
      field: "totalTransaction",
      headerName: "Transactions",
    },
    {
      field: "goldBookingAmount",
      headerName: "Gold Booking",
      render: (val, row) =>
        `₹ ${Number(row.goldBookingAmount || 0).toFixed(2)}`,
    },
    {
      field: "goldOutstandingAmount",
      headerName: "Gold Outstanding",
      render: (val, row) =>
        `₹ ${Number(row.goldOutstandingAmount || 0).toFixed(2)}`,
    },
    {
      field: "goldPendingAmount",
      headerName: "Gold Pending",
      render: (val, row) =>
        `₹ ${Number(row.goldPendingAmount || 0).toFixed(2)}`,
    },
    {
      field: "goldAdvanceAmount",
      headerName: "Gold Advance",
      render: (val, row) =>
        `₹ ${Number(row.goldAdvanceAmount || 0).toFixed(2)}`,
    },
    {
      field: "silverBookingAmount",
      headerName: "Silver Booking",
      render: (val, row) =>
        `₹ ${Number(row.silverBookingAmount || 0).toFixed(2)}`,
    },
    {
      field: "silverOutstandingAmount",
      headerName: "Silver Outstanding",
      render: (val, row) =>
        `₹ ${Number(row.silverOutstandingAmount || 0).toFixed(2)}`,
    },
    {
      field: "silverPendingAmount",
      headerName: "Silver Pending",
      render: (val, row) =>
        `₹ ${Number(row.silverPendingAmount || 0).toFixed(2)}`,
    },
    {
      field: "silverAdvanceAmount",
      headerName: "Silver Advance",
      render: (val, row) =>
        `₹ ${Number(row.silverAdvanceAmount || 0).toFixed(2)}`,
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        overflow: "auto",
        pb: 4,
      }}
    >
      <Box
        sx={{
          width: "100%",
          mt: 0,
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          pb: 3,
        }}
      >
        <Box p={2}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              mb: 3,
              color: "#0d47a1",
            }}
          >
            Booking Report
          </Typography>

          <CardContent sx={{ width: "100%", overflowX: "auto" }}>
            <Box sx={{ width: "100%", overflow: "auto" }}>
              <TableCompo
                columns={columns}
                data={bookingReport || []}
                totalCount={bookingReportTotal}
                onTableChange={handleTableChange}
                page={pagination.page}
                limit={pagination.limit}
                loading={bookingReportLoading}
              />
            </Box>
          </CardContent>
        </Box>
      </Box>
    </Box>
  );
};

export default BookingReport;
